import Vue from "vue"
import SheetExporter from "./index.vue"


let SheetExporterConstructor = Vue.extend(SheetExporter);

let instance;

const showSheetExporter = function(propsData) {
  return new Promise((resolve, reject) => {
    instance = new SheetExporterConstructor({
      propsData: {
        ...propsData
      },
      watch: {
        dialogVisible: (newVal) => {
          if (!newVal) {
            instance.$destroy();
          }
        }
      }
    }).$mount();
    document.body.appendChild(instance.$el);
    instance.visible = true;
    resolve();
  })
}

export default showSheetExporter;
